import { render, staticRenderFns } from "./StudentCoursesAndVouchers.vue?vue&type=template&id=85242ffc"
import script from "./StudentCoursesAndVouchers.vue?vue&type=script&lang=ts"
export * from "./StudentCoursesAndVouchers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports